import React from 'react'
import Question from './Component/Question'
function App() {
  return (
    <div>
    <Question/>
    </div>
  )
}

export default App

